/* Trade page anchors and its inline Typeform embed. Typeform owns application handling. */
(function () {
  'use strict';

  window.aykahTradeFormReady = function () {
    document.querySelectorAll('[data-rth-embed]').forEach(function (panel) {
      panel._ready = true;
      var help = panel.parentElement.querySelector('[data-rth-form-help]');
      if (help) help.hidden = true;
    });
  };

  function wireScrollLinks() {
    document.querySelectorAll('[data-rth-scroll]').forEach(function (link) {
      if (link.dataset.rthWired) return;
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      link.dataset.rthWired = 'true';
      link.addEventListener('click', function (event) {
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); }
        catch (error) { target.focus(); }
      });
    });
  }

  function wireEmbeds() {
    var panels = document.querySelectorAll('[data-rth-embed]');
    if (!panels.length) return;
    panels.forEach(function (panel) {
      if (panel.dataset.rthInitialized) return;
      panel.dataset.rthInitialized = 'true';
      panel._ready = false;
      var help = panel.parentElement.querySelector('[data-rth-form-help]');
      window.setTimeout(function () {
        if (!panel._ready && help) help.hidden = false;
      }, 10000);
    });

    var src = 'https://embed.typeform.com/next/embed.js';
    if (!document.querySelector('script[src="' + src + '"]')) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onerror = function () {
        document.querySelectorAll('[data-rth-form-help]').forEach(function (help) {
          help.hidden = false;
        });
      };
      document.head.appendChild(script);
    } else if (window.tf && window.tf.load) {
      window.tf.load();
    }
  }

  function init() {
    wireScrollLinks();
    wireEmbeds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
